function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0909 2.08347C14.0909 3.23413 13.1581 4.16693 12.0075 4.16693C10.8568 4.16693 9.924 3.23413 9.924 2.08347C9.924 0.9328 10.8568 0 12.0075 0C13.1581 0 14.0909 0.9328 14.0909 2.08347ZM9.59387 4.72217H14.4211C15.8539 4.72217 17.0147 5.88323 17.0144 7.31577V13.8462C17.0144 14.3296 16.6227 14.7216 16.1389 14.7216C15.6557 14.7216 15.264 14.3296 15.264 13.8462V7.40563C15.264 7.23843 15.128 7.1027 14.9603 7.1027C14.7931 7.1027 14.6576 7.23843 14.6576 7.40563V14.3747V21.8664C14.6576 22.4926 14.1499 23 13.5237 23C12.8976 23 12.3904 22.4926 12.3904 21.8664V14.3611C12.3904 14.1494 12.2189 13.9776 12.0072 13.9776C11.7957 13.9776 11.6243 14.1494 11.6243 14.3611V21.8664C11.6243 22.4926 11.1171 23 10.4907 23C9.8648 23 9.35733 22.4926 9.35733 21.8664L9.35707 14.3747V7.40563C9.35707 7.23843 9.22187 7.1027 9.05413 7.1027C8.8864 7.1027 8.7512 7.23843 8.7512 7.40563V13.8464C8.7512 14.3299 8.35893 14.7219 7.87573 14.7219C7.39227 14.7219 7 14.3299 7 13.8464V7.31603C7 5.88323 8.16107 4.72217 9.59387 4.72217Z"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/person.4f2fde9d.svg";
export { SvgComponent as ReactComponent };